<template>
    <div class="sa-row">
        <div class="sa-col-xs12 sa-col-sm12 sa-col-md12 sa-col-lg12 ">
            <div class="sa-card sa-card-gray sa-card-noshadow sa-h-xs sa-h-sm">
                <strong class="sa-d-block">Filters</strong>
                <div class="sa-appoint-radio">
                    <span>
                        <input type="radio" v-model="selectedService" id="all" name="all" value="all"
                            @change="selectFilter" />
                        <label for="all">All Members</label>
                    </span>
                    <span>
                        <input type="radio" v-model="selectedService" id="active" name="active" value="active"
                            @change="selectFilter" />
                        <label for="active">Active</label>
                    </span>
                    <span>
                        <input type="radio" v-model="selectedService" id="inactive" name="inactive" value="inactive"
                            @change="selectFilter" />
                        <label for="inactive">Inactive</label>
                    </span>
                </div>
            </div>
            <div class="sa-form-group sa-h-md-up">
                <i class="icon-down-arrow sa-form-icon"></i>
                <select class="sa-form-control" v-model="selectedService" @change="selectFilter">
                    <option value="all">
                        All Members
                    </option>
                    <option value="active">
                        Active
                    </option>
                    <option value="inactive">
                        Inactive
                    </option>
                </select>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        slctService: {
            type: String
        }
    },
    data() {
        return {
            selectedService: JSON.parse(JSON.stringify(this.slctService)),
        }
    },
    methods: {
        selectFilter: function () {
            this.$emit('select-filter', this.selectedService)
        }
    },
}
</script>
